module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("chkbr"))).then(() => parcelRequire('hEqeo'));